<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="d-flex align-items-center justify-content-center mt-5 mb-10">
      <BaseIcon size="xxSmall">
        <CampaignIcon />
      </BaseIcon>
      <h1 class="text-uppercase mb-0 ms-5">{{ $t('campaigns') }}</h1>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <CreateCampaignButton />
    </div>
    <!-- CAMPAIGNS -->
    <div class="mt-4">
      <template v-if="user">
        <CampaignListTable />
      </template>
    </div> <!-- END CAMPAIGNS -->
  </MainLayout>
</template>

<script>

import { mapState } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import CampaignIcon from '@/components/common/Icon/CampaignIcon'
import CampaignListTable from '@/components/campaigns/CampaignListTable'
import CreateCampaignButton from '@/components/campaigns/CreateCampaignButton'
import MainLayout from '@/components/layouts/MainLayout'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

export default {
  components: {
    BaseIcon,
    CampaignIcon,
    CampaignListTable,
    CreateCampaignButton,
    MainLayout,
    Shortcuts
  },
  data () {
    return {}
  },
  metaInfo () {
    return {
      title: this.$t('campaigns')
    }
  },
  created () {
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  }
}
</script>
